import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import Button from '../Button/Button';
import { IconClose, IconInfo } from '../../assets/icon';
import useOutsideClick from '../../hooks/useOutsideClick';

const Badge = ({
  text, type, containerStyle, onClose, info
}) => {
  const ref = useRef(null);
  const [infoVisibility, setInfoVisibility] = useState(false);
  useOutsideClick(ref, () => setInfoVisibility(false));

  const typeClasses = {
    primary: 'bg-primary text-white dark:bg-[#0d1b2a] dark:text-primary dark:border dark:border-primary/50',
    white: `
      bg-white text-romanSilver dark:bg-[#1b263b] dark:text-[#e0e1dd]
      dark:border dark:border-[#415a77]/60
    `,
    light: `
      bg-background-main text-romanSilver dark:bg-[#1b263b] dark:text-[#e0e1dd]
      dark:border dark:border-[#415a77]/60
    `,
    secondary: `
      bg-secondary text-text-main dark:bg-[#1b263b] dark:text-[#e0e1dd]
      dark:border dark:border-[#415a77]/60
    `,
    success: 'bg-success text-white dark:bg-[#0d1b2a] dark:text-success dark:border dark:border-success/50',
    info: 'bg-info text-white dark:bg-[#0d1b2a] dark:text-info dark:border dark:border-info/50',
    warning: 'bg-warning text-white dark:bg-[#0d1b2a] dark:text-warning dark:border dark:border-warning/50',
    danger: 'bg-danger text-white dark:bg-[#0d1b2a] dark:text-danger dark:border dark:border-danger/50',
    dark: 'bg-dark text-white',
    lightPrimary: `
      bg-primary-light text-primary dark:bg-[#0d1b2a] dark:text-primary
      dark:border dark:border-primary/50
    `,
    lightSuccess: `
      bg-success-light text-success dark:bg-[#0d1b2a] dark:text-success
      dark:border dark:border-success/50
    `,
    lightWarning: `
      bg-warning-light text-warning dark:bg-[#0d1b2a] dark:text-warning
      dark:border dark:border-warning/50
    `,
    lightDanger: `
      bg-danger-light text-danger dark:bg-[#0d1b2a] dark:text-danger
      dark:border dark:border-danger/50
    `,
    lightInfo: `
      bg-info-light text-info dark:bg-[#0d1b2a] dark:text-info
      dark:border dark:border-info/50
    `,
  };

  return (
    <div
      className={`px-[6px] py-[4px] text-[11px] w-max rounded-[5px]
      ${typeClasses[type] || typeClasses.primary} ${containerStyle}`}
    >
      <div className="flex flex-row justify-between items-center">
        {text}
        {onClose
          && (
            <Button
              icon={<IconClose />}
              type={type}
              containerStyle="p-0 ml-[7px]"
              onClick={onClose}
            />
          )}
        {info
          && (
            <Button
              icon={<IconInfo />}
              type={type}
              containerStyle="p-0 ml-[7px]"
              onClick={() => setInfoVisibility(!infoVisibility)}
            />
          )}
      </div>
      {infoVisibility && (
      <div
        className="px-[10px] py-[8px] absolute bottom-[110%] right-0 bg-background-main
        dark:bg-background-dark rounded-[4px]"
        ref={ref}
      >
        {info}
      </div>
      )}
    </div>
  );
};

Badge.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.string,
  containerStyle: PropTypes.string,
  onClose: PropTypes.func,
  info: PropTypes.node,
};

Badge.defaultProps = {
  type: 'primary',
  containerStyle: '',
  onClose: undefined,
  info: undefined
};

export default Badge;
